import React from 'react';
import { Mail, Users, Globe } from 'lucide-react';
export const Contact = () => {
  return <div className="pt-20" data-id="element-2698">
      <section className="py-16 bg-secondary/5" data-id="element-2699">
        <div className="container mx-auto px-4" data-id="element-2700">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-8" data-id="element-2701">
            Contact Us
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2702">
            We'd love to hear from you. Whether you're interested in joining our
            community, exploring partnerships, hosting a Salon in your city, or
            simply learning more about what we do — we're here to connect.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2703">
        <div className="container mx-auto px-4" data-id="element-2704">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2705">
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2706">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2707">
                <Mail size={24} className="text-secondary" data-id="element-2708" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2709">
                General Inquiries
              </h2>
              <p className="text-secondary mb-4" data-id="element-2710">
                Have a question about The Networking Salon or want to know more
                about our upcoming launches?
              </p>
              <p className="font-medium" data-id="element-2711">
                👉 Email us at:{' '}
                <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2712">
                  info@thenetworkingsalon.live
                </a>
              </p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2713">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2714">
                <Users size={24} className="text-secondary" data-id="element-2715" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2716">
                Partnerships & Collaborations
              </h2>
              <p className="text-secondary mb-4" data-id="element-2717">
                If you're looking to co-create events, collaborate on
                opportunities, or explore how we can support each other's
                initiatives:
              </p>
              <p className="font-medium" data-id="element-2718">
                👉 Reach us at:{' '}
                <a href="mailto:partner@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2719">
                  partner@thenetworkingsalon.live
                </a>
              </p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2720">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2721">
                <Globe size={24} className="text-secondary" data-id="element-2722" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2723">
                Host a Salon in Your City
              </h2>
              <p className="text-secondary mb-4" data-id="element-2724">
                Passionate about building community in your city? We're
                expanding to 30 cities worldwide and would love to hear from
                potential city leads.
              </p>
              <p className="font-medium" data-id="element-2725">
                👉 Apply or express interest via:{' '}
                <a href="mailto:andre@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2726">
                  andre@thenetworkingsalon.live
                </a>
              </p>
            </div>
          </div>
          <div className="mt-16 border-t border-gray-200 pt-16" data-id="element-2727">
            <h2 className="text-2xl font-bold text-center text-secondary-dark mb-8" data-id="element-2728">
              Stay Connected
            </h2>
            <div className="flex justify-center space-x-6" data-id="element-2729">
              <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="flex items-center border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50" data-id="element-2730">
                <div className="w-6 h-6 bg-secondary rounded-sm mr-2" data-id="element-2731"></div>
                <span data-id="element-2732">LinkedIn</span>
              </a>
              <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="flex items-center border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50" data-id="element-2733">
                <div className="w-6 h-6 bg-secondary rounded-full mr-2" data-id="element-2734"></div>
                <span data-id="element-2735">Instagram</span>
              </a>
            </div>
            <p className="text-center text-secondary mt-8" data-id="element-2736">
              <span className="font-bold" data-id="element-2737">📌 Quick Note</span>: We're a global
              initiative with local hubs, so we do our best to respond within 48
              hours. If your inquiry is city-specific, please include your
              location in your message.
            </p>
          </div>
        </div>
      </section>
    </div>;
};